import R from 'ramda';

export const mainCategories = [
  {
    mainCategory: 'Updates',
    subCategories: [
      { text: 'General Update', val: 'general', hashtag: '#update' },
      { text: 'Special Offers', val: 'special_offers', hashtag: '#specialoffer' },
      { text: 'New Products', val: 'new_product', hashtag: '#newproduct' },
      { text: 'New Locations', val: 'new_location', hashtag: '#newlocation' },
      { text: 'New Packages', val: 'new_package', hashtag: '#newpackage' },
      { text: 'Property Renovations', val: 'property_renovations', hashtag: '#renovations' },
      { text: 'New Blackout Dates', val: 'blackout_dates', hashtag: '#blackouts' },
      { text: 'Team Update', val: 'team_update', hashtag: '#teamupdate' },
      { text: 'Marketing Coop Opportunity', val: 'marketing_coop_opportunity', hashtag: '#mktgcoop' },
    ],
  },
  {
    mainCategory: 'Industry Insights',
    subCategories: [
      { text: 'Industry Knowledge & Questions', val: 'industry_knowledge', hashtag: '#help' },
      { text: 'Recommendations', val: 'recommendations', hashtag: '#recommendations' },
      { text: 'Industry Events', val: 'events', hashtag: '#events' },
      { text: 'Job Postings', val: 'jobs', hashtag: '#jobs' },
      { text: 'Industry Lobbying', val: 'lobbying', hashtag: '#lobbying' },
      { text: 'Surveys', val: 'survey', hashtag: '#survey' },
    ],
  },
  {
    mainCategory: 'Training & Famils',
    subCategories: [
      { text: 'Buyer/Agent Training Materials', val: 'buyer_agent_training_materials', hashtag: '#training' },
      { text: 'Webinar Announcements', val: 'webinar_announcements', hashtag: '#webinar' },
      { text: 'Famil Trips', val: 'famil_trips', hashtag: '#famtrip' },
      { text: 'In-Market Sales Trips', val: 'inmarket_sales_trips', hashtag: '#salestrip' },
    ],
  },
  {
    mainCategory: 'Destination Updates',
    subCategories: [
      { text: 'Visitation Statistics', val: 'visitation_statistics', hashtag: '#stats' },
      { text: 'Destination Itineraries', val: 'destination_itineraries', hashtag: '#itineraries' },
      { text: 'Destination Specialist Updates', val: 'destination_specialist_updates', hashtag: '#specialists' },
      { text: 'Disaster Recovery Update', val: 'disaster_recovery_update', hashtag: '#openforbiz' },
    ],
  },
];

// returns array of vals for main category
export const getSubcategoriesFromMain = (mainCategory) => R.call(R.compose(
  R.pluck('val'),
  R.prop(0),
  R.pluck('subCategories'),
  R.filter(obj => obj.mainCategory === mainCategory)
), mainCategories);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/newPost/categoryOptions.js